"use strict";
/**
 * Общие контракты HTTP API (документ «Технический план», §7).
 *
 * Формат ошибки и формат списка едины для всех endpoint-ов.
 * DTO никогда не содержат password hash, session token, reset token,
 * серверный путь хранения файла и прочие внутренние секреты.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.CSRF_HEADER = exports.REQUEST_ID_HEADER = exports.MAX_PAGE_SIZE = exports.DEFAULT_PAGE_SIZE = exports.HTTP_STATUS_BY_ERROR_CODE = exports.API_ERROR_CODES = void 0;
// --- Ошибки --------------------------------------------------------------
exports.API_ERROR_CODES = [
    'VALIDATION_ERROR',
    'UNAUTHENTICATED',
    'FORBIDDEN',
    'NOT_FOUND',
    'CONFLICT',
    'PAYLOAD_TOO_LARGE',
    'UNSUPPORTED_MEDIA_TYPE',
    'RATE_LIMITED',
    'INTERNAL_ERROR',
    'SERVICE_UNAVAILABLE',
];
exports.HTTP_STATUS_BY_ERROR_CODE = {
    VALIDATION_ERROR: 400,
    UNAUTHENTICATED: 401,
    FORBIDDEN: 403,
    NOT_FOUND: 404,
    CONFLICT: 409,
    PAYLOAD_TOO_LARGE: 413,
    UNSUPPORTED_MEDIA_TYPE: 415,
    RATE_LIMITED: 429,
    INTERNAL_ERROR: 500,
    SERVICE_UNAVAILABLE: 503,
};
/** Значение по умолчанию и предел размера страницы. Безлимитных списков нет. */
exports.DEFAULT_PAGE_SIZE = 50;
exports.MAX_PAGE_SIZE = 200;
// --- Заголовки -----------------------------------------------------------
/** Заголовок сквозного идентификатора запроса: попадает в логи и в тело ошибки. */
exports.REQUEST_ID_HEADER = 'x-request-id';
/** Заголовок CSRF-токена для запросов, изменяющих состояние. */
exports.CSRF_HEADER = 'x-csrf-token';
//# sourceMappingURL=api.js.map